import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { GatewayPaymentFragment } from '@websky/graphql';
import { PaymentPage, PaymentType } from '../../../types';
import { useTheme } from '../../../../theme';
import Gateway from '../Gateway';
import CopyCode from '../../CopyCode/CopyCode';

interface Props {
	frameInfo: GatewayPaymentFragment;
	headerTitle?: string;
	isPreOpened?: boolean;
	isAwaitingGatewayPayload?: boolean;
	onClick: (page: PaymentPage) => void;
}

const Qiwi: React.FC<Props> = ({
	frameInfo,
	headerTitle,
	isPreOpened,
	isAwaitingGatewayPayload,
	children,
	onClick
}) => {
	const { Qiwi: css } = useTheme('PaymentForm');
	const { t } = useTranslation('PaymentForm');

	const onClickGateway = useCallback(() => {
		const paymentCode = frameInfo?.paymentCode;

		onClick({
			title: headerTitle,
			type: PaymentType.Qiwi,
			content: (
				<div className={css.root}>
					{paymentCode ? (
						<>
							{t('Payment code')}:
							<CopyCode className={css.copy} code={paymentCode} />
							<div className={css.info}>
								{t(
									'Please, click «Edit Order» after successful payment in QIWI app to open your order.'
								)}
							</div>
						</>
					) : (
						t('Failed to get billing code')
					)}
				</div>
			)
		});
	}, [frameInfo, onClick]);

	useEffect(() => {
		if (isPreOpened && (frameInfo?.paymentCode || !isAwaitingGatewayPayload)) {
			onClickGateway();
		}
	}, [isPreOpened, frameInfo?.paymentCode, isAwaitingGatewayPayload]);

	return (
		<Gateway
			onClick={onClickGateway}
			header={children}
			type={t('Payment by QIWI')}
			paymentType={PaymentType.Qiwi}
		/>
	);
};

export default Qiwi;
